import React, { useRef } from 'react';
import classNames from 'classnames';
import { useInternalSession } from 'hooks/useInternalSession';
import { isClientSide, isHappybetSite, isSnaiSite } from 'utility/constant';
import { AnchorLink, AnchorLinkType } from 'components/anchorLink';
import { AccordionItem } from 'components/footer/accordionItem';
import styles from './FooterNavigation.module.scss';
import { Icon, IconsEnum } from 'components/Icons';

declare global {
  interface Window {
    Cookiebot: any;
    CookieConsent: any;
  }
}
export type FooterNavigationProps = {
  navigation: NavigationBlock[];
};

export type NavigationBlock = {
  id: string;
  title: string;
  menuList: MenuItem[];
};
export type MenuItem = {
  id: string;
  label: string;
  links: AnchorLinkType[];
};
export const FooterNavigation = ({ navigation }: FooterNavigationProps) => {
  const idSettingCookie = '64024602';
  const idSettingCookieHappybet = '/cookie-edit';

  const containerRef = useRef<HTMLDivElement>(null);

  const onCookiebotDialogHandler = (): void => {
    if (isClientSide && isSnaiSite) {
      // TODO: check how to remove EventListener for CookiebotOnDialogDisplay
      window.addEventListener('CookiebotOnDialogDisplay', function () {
        document.querySelector('.hinto-cookiebanner-modal') &&
          document.querySelector('.hinto-cookiebanner-modal')!.classList.add('is-visible');
      });

      window.Cookiebot.show();
    } else if (isClientSide && isHappybetSite) {
      window.CookieConsent.renew();
    }
  };

  const doToggle = (id: string) => {
    const ck = containerRef.current?.querySelector<HTMLInputElement>(`#${id}`);
    if (ck instanceof HTMLInputElement) {
      ck.checked = ck.checked ? false : true;
    }
  };
  return (
    <div className={styles.container} ref={containerRef}>
      {navigation.map(({ id, title, menuList }, idx) => (
        <section
          id={id}
          key={`section-${id}-${idx}`}
          className={classNames(styles.menuContainer)}
          suppressHydrationWarning
        >
          <input type="checkbox" id={`ck-${id}-${idx}`} tabIndex={-1} />
          <label htmlFor={`ck-${id}-${idx}`} className={styles.toggler}>
            <button onKeyDown={(ev) => (ev.key === 'Enter' ? doToggle(`ck-${id}-${idx}`) : undefined)}>
              <h5 className={styles.titleSection}>{title}</h5>
            </button>
            <Icon iconId={IconsEnum.CHEVRON_DOWN} className={styles.chevron} />
          </label>
          <nav className={styles.navigation}>
            <ul className={styles.menu}>
              {menuList?.map((item, idx) => {
                const key = `${id}-${idx}-${item.links[0].id}`;
                return item.id === idSettingCookie ||
                  item.label === 'Impostazioni cookie' ||
                  item.links[0].href === idSettingCookieHappybet ? (
                  <li key={key} className={styles.menuItem}>
                    <a
                      onClick={onCookiebotDialogHandler}
                      className={classNames(styles.anchorLink, styles.anchorLinkCookie)}
                    >
                      {item.label}
                    </a>
                  </li>
                ) : (
                  <li key={key} className={styles.menuItem}>
                    <AnchorLink href={item.links[0].href} className={styles.anchorLink}>
                      {item.label}
                    </AnchorLink>
                  </li>
                );
              })}
            </ul>
          </nav>
        </section>
      ))}
    </div>
  );
};